<template>
	<div class="container">
    <home-header class="header"></home-header>
    <div class="refreshText"></div>
    <div class="list">
        <home-banner v-if="banners && banners.length > 0" :items="banners"></home-banner>
        <home-menu></home-menu>
        <home-topic></home-topic>
        <home-product-list  v-for="(item,index) in topicList"  :key="index" :items="item" :id="item.id" :title="item.title" :type="popular" v-if="topicList && topicList.length > 0"></home-product-list>
    </div>
  <back-top v-if="isshowBacktop" :target="target" :bottom="60"></back-top>
	</div>
</template>

<script>
import { Header, Indicator, Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { HeaderItem } from '../../components/common';
import BackTop from '../../components/common/BackTop';
import HomeHeader from './child/HomeHeader';
import HomeBanner from './child/HomeBanner';
import HomeTopic from './child/HomeTopic';
import HomeMenu from './child/HomeMenu';
import HomeProductList from './child/HomeProductList';
import { ENUM } from '../../const/enum';

export default {
  name: 'home',
  components: {
    'home-header':HomeHeader,
    'home-banner':HomeBanner,
    HomeMenu,
    HomeTopic,
    HomeProductList,
    BackTop,
  },
  data() {
    return {
      isshowBacktop: false,
      popular: ENUM.SORT_KEY.POPULAR,
      sale: ENUM.SORT_KEY.SALE,
      recently: ENUM.SORT_KEY.DATE,
      shared_link: '',
      allLoaded:true
    };
  },
  mounted() {
    this.init()
  },
  activated(){
    this.target.addEventListener('scroll', (event) => {
      if (this.target.scrollTop) {
        this.offsetTop = this.target.scrollTop
      } 
    });
    if(this.offsetTop){
      this.target.scrollTop = this.offsetTop
    }
    this.init()
  },
  created: function() {
    if (this.banners && this.banners.length) {

    }else{
      Indicator.open()
      this.fetchHomeBanner({page: 1, per_page: 10}).then(
        response => {
        },
        error => {
        }
      )
    }

    if(this.topicList && this.topicList.length){
      
    }else{
      Indicator.open();
      this.fetchTopicList({display_area:1,page:1,per_page:100}).then(
        response => {
          Indicator.close();
        },
        error => {
          Indicator.close();
        }
      )
    }
    this.init()
    // this.loadConfig()
  },
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
      hasVersion: state => state.auth.version,
      config: state => state.config.config,    
      banners: state => state.home.banners,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      topicList: state => state.home.topicList,
    }),
  },
  methods: {
    ...mapMutations({
      saveToken: 'saveToken',
      clearToken: 'signout'
    }),
    ...mapActions({
      fetchHomeBanner: 'fetchHomeBanner',
      fetchTopicList: 'fetchTopicList',
      fetchConfig: 'fetchConfig',
      fetchHomeAddress:'fetchHomeAddress'
    }),
    init(){
      // if(window.version && Number(window.version.replace('.',"").replace('.',""))>104){
      //   if(!this.hasVersion)this.clearToken()
      // }
      var element = this.$el;
      var that = this;
      var dom = document.querySelector('.list');
      var  _startPos = 0;
      var  _transitionHeight = 0;
      if (dom) {
        dom.addEventListener('scroll', event => {
          let params = {
            top: dom.scrollTop,
            height: dom.scrollHeight
          };
          if (params.top >= 100) {
            this.isshowBacktop = true;
          } else {
            this.isshowBacktop = false;
          }
        });
      }
      this.target = document.querySelector('.list');
      var _element = document.querySelector('.list'),
          _refreshText = document.querySelector('.refreshText'),
          _startPos = 0,
          _transitionHeight = 0;
       if (_element) {
          _element.addEventListener('touchstart', function (e) {
            if(dom.scrollTop != 0) return false
            _startPos = e.touches[0].pageY;
            _element.style.position = 'relative';
            _element.style.transition = 'transform 0s';
          }, false);

          _element.addEventListener('touchmove', function (e) {
            if(dom.scrollTop != 0) return false
            _transitionHeight = e.touches[0].pageY - _startPos;
            if (_transitionHeight > 20 && _transitionHeight < 60) {
              _refreshText.innerText = '下拉刷新';
              _element.style.transform = 'translateY(' + _transitionHeight + 'px)';
              if (_transitionHeight > 55) {
                _refreshText.innerText = '释放更新';
              }
            }
          }, false);
          _element.addEventListener('touchend', function (e) {
            if(dom.scrollTop == 0 & _transitionHeight >20){
              _element.style.transition = 'transform 0.5s ease 1s';
              _element.style.transform = 'translateY(0px)';
              _refreshText.innerText = '更新中...';
              setTimeout(()=>{window.location.reload()},300);
            }
          }, false);
       }
    },
    loadConfig() {
      // this.fetchConfig().then(response => {
      //   let wechat = response.config['wechat.web']
      //   let openid = this.$cookie.get('o')
      //    var keyword = window.location.href;
      //       if(keyword.indexOf("?u=") >= 0 ) { //判断url地址中是否包含link字符串
      //           if(!this.isOnline){
      //              this.$router.push({
      //               name: 'signin',
      //               params: { isFromShare: true }
      //       });
      //           }
      //     }
      //   // 微信已授权
      //   // if (openid) {
      //   //   if (this.isOnline) {
      //   //     if (wechat && this.shared_link) {
      //   //       this.setWechatConfig(wechat, this.shared_link)
      //   //     }
      //   //   } else {
      //   //     if (wechat) {
      //   //       let callbackUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;              
      //   //       this.setWechatConfig(wechat, callbackUrl)
      //   //     }
      //   //   }
      //   // } else {
      //   //   if (this.wxApi.isweixin()) {                       
      //   //     let callbackUrl = encodeURIComponent(window.location.protocol+"//"+window.location.host+window.location.pathname);
      //   //     let scope = "snsapi_base";            
      //   //     let invite_code = this.$cookie.get('r'); // 获取邀请人id
      //   //     if(invite_code) {
      //   //       let locationRef = env.API_HOST + '/v2/ecapi.auth.web?vendor=' + ENUM.SOCIAL_VENDOR.WEIXIN + '&scope=' + scope + '&referer=' + callbackUrl + '&invite_code=' + invite_code;
      //   //       window.location.href = locationRef;
      //   //     } else {
      //   //       let locationRef = env.API_HOST + '/v2/ecapi.auth.web?vendor=' + ENUM.SOCIAL_VENDOR.WEIXIN + '&scope=' + scope + '&referer=' + callbackUrl;
      //   //       window.location.href = locationRef;
      //   //     };           
      //   //   }
      //   // }
      // }, error => {        
      // })
    },
    // loadBonusData() {
    //   recommendBonusInfo().then(res => {
    //     if (res && res.bonus_info) {
    //       let bonus_info = res.bonus_info          
    //       this.shared_link = bonus_info && bonus_info.shared_link ? bonus_info.shared_link : null
    //       let wechat = this.config ? this.config['wechat.web'] : null              
    //       if (this.shared_link && wechat) {            
    //         this.setWechatConfig(wechat, this.shared_link)
    //       }
    //     }
    //   }, error => {        
    //   })
    // },
    // setWechatConfig(config, link) {       
    //   this.wxApi.wxRegister(config, '推荐分成', null, '点击链接关注小店成为推广员，拿取更多分成', link)
    // },
    saveAuthInfo() {
      // let openid = this.$cookie.get('o');
      // let token = this.$cookie.get('t');
      // if (openid && token && !self.isOnline) {        
      //   this.saveToken({ token: token });
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: auto;
  position: absolute;
  bottom: 45px;
  top: 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
.refreshText {
  background-color: #ffffff;
  position: absolute;
  text-align: center;
  top: 40px;
  padding-top: 10px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}
.list {
  background-color: #ffffff;
  position: absolute;
  top: 44px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue